/* eslint-disable no-restricted-syntax */
import { getArrowFile, SessionPostData } from 'utils/api'

/**
 * Fetches Arrow IPC buffer from data URL.
 * Returns raw buffer instead of converting to objects for memory efficiency.
 */
const getArrowBufferFromDataUrl = async (dataUrl: string): Promise<Uint8Array | null> => {
  const arrowResults = await getArrowFile(dataUrl)
  const { status: arrowFileStatus } = arrowResults

  if (arrowFileStatus === 200) {
    // Return raw IPC buffer - serializable and memory-efficient (200 MB for 100k cells)
    const buffer = new Uint8Array(await arrowResults.arrayBuffer())
    return buffer
  }
  return null
}

type GetSessionDataParams = {
  sessionId?: number
  sessionData?: SessionPostData
  sessionStatus?:number
}

export type SessionData = { arrowBuffer?: Uint8Array; sessionData?: SessionPostData }

export const getSessionData = async (params:GetSessionDataParams):Promise<SessionData> => {
  const { sessionId,sessionData,sessionStatus } = params

  if (!sessionId) return {}

  if (sessionStatus === 200 && sessionData?.data_url) {
    const arrowBuffer = await getArrowBufferFromDataUrl(sessionData.data_url)

    if (arrowBuffer) {
      return { arrowBuffer, sessionData }
    }
  }

  return {}
}

export default getSessionData
